import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close-circle-2.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "supplierDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "supplierDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-rl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title text-title",
  id: "supplierDetailsModalLabel"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = {
  key: 0,
  class: "modal-body p-0"
}
const _hoisted_9 = { class: "details-list list-style" }
const _hoisted_10 = { class: "fs-14 text-title" }
const _hoisted_11 = { class: "fs-14 fw-bold text-title" }
const _hoisted_12 = { class: "fs-14 text-title" }
const _hoisted_13 = { class: "fs-14 fw-bold text-title" }
const _hoisted_14 = { class: "fs-14 text-title" }
const _hoisted_15 = { class: "fs-14 fw-bold text-title" }
const _hoisted_16 = { class: "fs-14 text-title" }
const _hoisted_17 = { class: "fs-14 fw-bold text-title" }
const _hoisted_18 = { class: "fs-14 text-title" }
const _hoisted_19 = { class: "fs-14 fw-bold text-title" }
const _hoisted_20 = { class: "fs-14 text-title" }
const _hoisted_21 = { class: "fs-14 fw-bold text-title" }
const _hoisted_22 = { class: "fs-14 text-title" }
const _hoisted_23 = { class: "fs-14 fw-bold text-title" }
const _hoisted_24 = { class: "fs-14 text-title" }
const _hoisted_25 = {
  key: 1,
  class: "modal-body p-4 text-center"
}
const _hoisted_26 = { class: "modal-footer pt-20 pb-35 justify-content-end" }
const _hoisted_27 = {
  type: "button",
  class: "btn style-four px-xxl-6",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("supplier_page.details_title")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close p-0",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('common.close')
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: _ctx.$t('common.close')
            }, null, 8, _hoisted_7)
          ], 8, _hoisted_6)
        ]),
        (_ctx.supplier)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("supplier_page.supplier_code")), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.supplier.code || _ctx.$t("supplier_page.not_available_short")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("supplier_page.supplier_name")), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.supplier.name || _ctx.$t("supplier_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("supplier_page.phone")), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.supplier.phone || _ctx.$t("supplier_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("supplier_page.email")), 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.supplier.email || _ctx.$t("supplier_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("supplier_page.country")), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.supplier.country || _ctx.$t("supplier_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("supplier_page.company_name")), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.supplier.com_name || _ctx.$t("supplier_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("supplier_page.address")), 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.supplier.address || _ctx.$t("supplier_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("supplier_page.status")), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(['fs-14', 'fw-bold', _ctx.supplier.status ? 'text-success' : 'text-danger'])
                  }, _toDisplayString(_ctx.supplier.status ? _ctx.$t("supplier_page.status_active") : _ctx.$t("supplier_page.status_inactive")), 3)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("supplier_page.no_supplier_selected")), 1)
            ])),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", _hoisted_27, _toDisplayString(_ctx.$t("common.close")), 1)
        ])
      ])
    ])
  ]))
}